module.exports = __webpack_public_path__ + "media/images/favicon/android-icon-192x192-f32010c77197b196f639a148264e33fc.png";